import { OUTSTANDING_SWITCH } from "../const";
import { ISubTask, ITask } from "../yoello-lib/modules/interfaces/ITask";
import { OUTSTANDING_BODY } from "../yoello-lib/modules/redux/actions/oustanding.actions";

export interface IOutstandingState {
  open: boolean;
  body: ITask[];
  doneTasks: number;
  totalTasks: number;
  venueId: string;
}

type ReduxAction = {
  type: string;
  payload?: any;
};

const INITIAL_STATE: IOutstandingState = {
  open: true,
  body: [],
  doneTasks: 0,
  totalTasks: 0,
  venueId: ""
};

const reducer = (state = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case OUTSTANDING_SWITCH:
      return { ...state, open: action.payload.state };
    case OUTSTANDING_BODY:
      let open;
      const venueId = action.payload.venueId;
      /**Checks if the onboarding model needs to open */
      if (state.venueId && venueId !== state.venueId ) {
        open = true;
      } else if (venueId === state.venueId
        && state.open === true) {
        open = true;
      } else {
        open = false;
      }

      const outstandingData = action.payload.tasks;
      const groupsTotal = outstandingData.length;
      const groupsDone = outstandingData.reduce(
        (total: number, group: ITask) =>
          (total += group.items.every((item: ISubTask) => item.complete) ? 1 : 0),
        0
      );

      return {
        ...state,
        body: outstandingData,
        open,
        doneTasks: groupsDone,
        totalTasks: groupsTotal,
        venueId
      };
    default:
      return state;
  }
};

export default reducer;
